import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';
import { RouteConstants } from '../../constants/constants';
import {  setDetailedView } from "src/slices/allOpportunitySlice";
// import {  setDetailedView } from "../../../src/";
import { useAppDispatch } from "src/store";
import { getMessage } from "src/message/utils";

export const ActionCellRenderer = (params: any) => {
    const [newDesign, setNewDesign] = useState(true);
    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    const handleViewDetails = () => {
        if (newDesign) {
            navigate(RouteConstants.ANOMALY_DETAILS_RELATIVE_PATH + `/${params.data.insight_id}`);
            dispatch(setDetailedView("detailed_view"));
        } 
    }
    const actionLabel = getMessage('app.anomalies.grid.column.value.viewdetails');
    return (
        <>
            <div className={'allopportunity-link'} onClick={handleViewDetails}>
                {actionLabel}</div>
        </>
    );
};